import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgQrcodeModule } from '../svg-qrcode/svg-qrcode.module';
import { LoadingComponentModule } from '../loading/loading.module';

import { StartTourButtonComponent } from '../start-tour-button/start-tour-button.component'


@NgModule({
    declarations: [
        StartTourButtonComponent
    ],
    imports: [
        CommonModule,
        SvgQrcodeModule,
        LoadingComponentModule
    ],
    exports: [
        StartTourButtonComponent
    ]
})
export class StartTourButtonModule { }
